/**
 * All Routes with specific props are available here.
 */
import React, { lazy } from "react";

import HomePage from "pages/HomePage";

import { SurveyRoutes } from "./Consts";
import AppliedJobs from "pages/AppliedJobs";

const Eligibility = lazy(async () => await import("pages/Eligibility"));

const PersonalitySurvey = lazy(
  async () => await import("pages/PersonalitySurvey")
);
const FollowUp1 = lazy(async () => await import("pages/FollowUp1"));
const FollowUp2 = lazy(async () => await import("pages/FollowUp2"));
const FollowUp3 = lazy(async () => await import("pages/FollowUp3"));

const JobSearch = lazy(async () => await import("pages/JobSearch"));
const SavedJobs = lazy(async () => await import("pages/SavedJobs"));
const About = lazy(async () => await import("pages/About"));

interface IRoute {
  readonly path: string;
  readonly component: React.FC<any>;
  readonly protected: boolean;
  readonly title?: string;
}

const allRoutes: readonly IRoute[] = [
  {
    path: "/",
    component: HomePage,
    protected: false,
  },

  {
    path: "/jobs/search",
    component: JobSearch,
    protected: true,
  },
  {
    path: "/jobs/saved",
    component: SavedJobs,
    protected: true,
  },
  {
    path: "/about",
    component: About,
    protected: false,
    title: "About",
  },
  {
    path: SurveyRoutes.elgiblity,
    component: Eligibility,
    protected: true,
  },
  {
    path: SurveyRoutes.personality,
    component: PersonalitySurvey,
    protected: true,
  },
  {
    path: SurveyRoutes.followUp1,
    component: FollowUp1,
    protected: true,
  },
  {
    path: SurveyRoutes.followUp2,
    component: FollowUp2,
    protected: true,
  },
  {
    path: SurveyRoutes.followUp3,
    component: FollowUp3,
    protected: true,
  },
  {
    path: "/jobs/applied",
    component: AppliedJobs,
    protected: true,
  },
];

export default allRoutes;
